<template>
  <div class="header-geolocation">
    <BaseDropdown :close-on-click="false" position="bottom-right">
      <template #activator>
        <button v-if="selectedRegion" class="button" type="button" :title="selectedRegion.name">
          <span class="name">{{ selectedRegion.name }}</span>
        </button>
      </template>

      <template #content="{ toggle }">
        <div class="dropdown-content">
          <p class="header">Это Ваш регион?</p>
          <span v-if="selectedRegion" class="value">{{ selectedRegion.name }}</span>
          <BaseButton name="Да, верно" @click="toggle(false)" />
          <BaseButton
            name=" Нет, изменить"
            theme-type="light"
            @click="openChangeRegionModal(toggle)"
          />
        </div>
      </template>
    </BaseDropdown>
  </div>
</template>

<script setup lang="ts">
  import { BaseDropdown } from '~/components/base-ui/dropdown'
  import { BaseButton } from '~/components/base-ui/buttons'
  import { useRegionModal } from '~/composables/regions/use-region-modal'
  import { useRegions } from '~/composables/regions/use-regions'

  const { openRegionModal } = useRegionModal()
  const { selectedRegion } = useRegions()

  const openChangeRegionModal = async (toggle: (value: boolean) => void) => {
    toggle(false)
    await openRegionModal()
  }
</script>

<style lang="scss" scoped>
  .header-geolocation {
    .button {
      display: flex;
      align-items: center;
      border: none;
      background: none;
      outline: none;

      @include hover-focus {
        cursor: pointer;
        transition: $trans-default;

        > .name {
          color: $color-kiwi-50;

          &::before {
            background-image: url("data:image/svg+xml,%3Csvg width='12' height='12' viewBox='0 0 12 12' fill='%231ccb01' stroke='%231ccb01' xmlns='http://www.w3.org/2000/svg' %3E%3Cpath d='M10.7519 1.27235L1.00705 3.78009L5.94033 5.45443L6.91116 10.5728L10.7519 1.27235Z' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round' /%3E%3C/svg%3E");
          }
        }
      }
    }

    .button > .name {
      @extend %font-12;

      overflow: hidden;
      position: relative;
      display: inline-block;
      max-width: 112px;
      padding-left: 20px;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: $color-potato-70;
      transition: color $trans-default;

      &::before {
        position: absolute;
        content: '';
        top: 2px;
        left: 0;
        width: 12px;
        height: 12px;
        background-image: url("data:image/svg+xml,%3Csvg width='12' height='12' viewBox='0 0 12 12' fill='%23101E2C' stroke='%231C1C1C' xmlns='http://www.w3.org/2000/svg' %3E%3Cpath d='M10.7519 1.27235L1.00705 3.78009L5.94033 5.45443L6.91116 10.5728L10.7519 1.27235Z' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round' /%3E%3C/svg%3E");
        background-repeat: no-repeat;
        transition: background-image $trans-default;
      }
    }

    .dropdown-content {
      display: grid;
      gap: 16px;
      width: 400px;
      padding: 32px;

      > .header {
        @extend %font-20, %font-weight-500;
      }

      > .svoi-button {
        width: 100%;
      }
    }
  }
</style>
